import { getCookie, setCookie } from './cookies';

const form = $('form#mc-embedded-subscribe-form');

const register = ($form) => {
	$('#mc-embedded-subscribe').val('Sending...');
	$.ajax({
		method: $form.attr('method'),
		url: $form.attr('action'),
		data: $form.serialize(),
		cache: false,
		dataType: 'json',
		contentType: 'application/json; charset=utf-8',
		error: (err) => {
			alert('Could not connect to the registration server. Please try again later.')
			console.log(err);
		},
		success: (data) => {
			$('#mc-embedded-subscribe').val('Sign Up');
			if (data.result === 'success') {
				console.log(data.msg);
				$('#mce-EMAIL').css('borderColor', 'green').val('');
				$('#subscribe-result').css('color', 'green');
				$('#subscribe-result').html('<p>Thank you for subscribing. We have sent you a confirmation email.</p>');
			} else {
				console.log(data.msg);
				$('#mce-EMAIL').css('borderColor', 'red')
				$('#subscribe-result').css('color', 'red')
				$('#subscribe-result').html('<p>' + data.msg.substring(4) + '</p>')
			}
		}
	})
};

export const newsletter = () => {
	const cookieName = 'newsletter-visible';
	const Newsletter = $('.newsletter');

	if (!getCookie(cookieName)) {
		Newsletter.removeClass('hidden');
	}

	$('.newsletter-trigger').on('click', e => {
		e.preventDefault();
		Newsletter.toggleClass('hidden');
		setCookie(cookieName, 'yes', 999)
	});

	Newsletter.find(form).on('submit', (event) => {
		if (event) event.preventDefault();
		register($('#mc-embedded-subscribe-form'));
	});

};
